// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hvvnqeurivxijwiazjyp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2dm5xZXVyaXZ4aWp3aWF6anlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0NzQ5NDgsImV4cCI6MjA3MjA1MDk0OH0.9e5hFl5cyH2cEixwiIjdVMZkhOcUrCL6FUiIm_RtFp0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});